var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-width:${_vm.chartProdutividade.chartData.labels.length * 8}px;max-width:100%;`)},[_c('horizontalBar-chart',{attrs:{"height":_vm.height,"chart-data":_vm.chartProdutividade.chartData,"extra-options":_vm.chartProdutividade.extraOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }